/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_InboxInputs */

const en_notify_inbox = /** @type {(inputs: Notify_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipe suggestions`)
};

const de_notify_inbox = /** @type {(inputs: Notify_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezeptvorschläge`)
};

/**
* | output |
* | --- |
* | "Recipe suggestions" |
*
* @param {Notify_InboxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_inbox = /** @type {((inputs?: Notify_InboxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_InboxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_inbox(inputs)
	return en_notify_inbox(inputs)
});